






















import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class CellCheckbox extends Vue {
    @Prop(Array) private checkboxes !: object[];
    @Prop({type: Array, default: []}) private valueList ?: any[];

    private resultList: any[] = [];
    private created() {
        this.resultList = this.valueList || [];
    }
    @Emit('change')
    private onChange() {
        return this.resultList;
    }
}
